module.exports = __webpack_public_path__ + "img/021.5d0590d5.png";